
import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
export default new Vuex.Store({
  state: {
    API_BASE_URL: process.env.VUE_APP_API_BASE_URL,
    BANK_URL: process.env.VUE_APP_BANK_URL,
    ENV: process.env.VUE_APP_ENVIRONMENT,
    LINE_MAINTENANCE: Boolean(process.VUE_APP_LINE_MAINTENANCE),
    connection: { isActive: false, msg: '' },
    currentCustomer: null,
    currentUser: null,
    signalrNotification: null,
    signalrMessagebox: null
  },
  getters: {
    getConnection (state) {
      return state.connection
    },
    getEnvironment (state) {
      return state.ENV
    },
    getCurrentCustomer (state) {
      return state.currentCustomer
    },
    getCurrentUser (state) {
      return state.currentUser
    }
  },
  mutations: {
    SET_CONNECTION (state, newValue) {
      state.connection = newValue
    },
    SET_CURRENT_CUSTOMER (state, customer) {
      state.currentCustomer = customer
    },
    SET_CURRENT_USER (state, newValue) {
      state.currentUser = newValue
    }
  },
  actions: {
    setCurrentUser: ({ commit }, newValue) => {
      commit('SET_CURRENT_USER', newValue)
    },
    setCurrentCustomer: ({ commit }, newValue) => {
      commit('SET_CURRENT_CUSTOMER', newValue)
    },
    initialize: ({ commit, state }) => {
    }
  }
})
